import {Pipe, PipeTransform} from '@angular/core';
import {DataAttribute, GroupedDataAttribute} from '@app/views/admin/application-settings/models/data-attribute.model';
import {ApplicationsService} from '@app/views/admin/provider/applications/applications.service';

@Pipe({
    name: 'ngcGetTaskAllowedMappingAttributes'
})
export class GetTaskAllowedMappingAttributesPipe implements PipeTransform {

    constructor(private applicationsService: ApplicationsService) { }

    transform(attributeList: DataAttribute[], attributesByType: GroupedDataAttribute, selectedProperty: DataAttribute): DataAttribute[] {
        return this.applicationsService.getTaskAllowedMappingAttributes(attributeList, attributesByType, selectedProperty);
    }
}
